import React from 'react';
import type { CurrencyType } from 'src/utils/stringUtils';
import HotelCardPrice from '../HotelCardPrice/HotelCardPrice';
import type { Availability } from '../../types';
import HotelCardExploreButton from '../HotelCardExploreButton';
import styles from './hotelCardPriceBlock.module.css';

type HotelCardPriceBlockProps = {
  instantConfirm: boolean;
  isFlexDates: boolean;
  isMapCard: boolean;
  price: number;
  currencyCode: CurrencyType;
  availability: Availability;
  isHotelOnly: boolean;
  hotelPageHref: string;
  isCardHovered: boolean;
  openInCurrentTab: boolean;
  datesInfo?: string;
};

const HotelCardPriceBlock: React.FC<HotelCardPriceBlockProps> = ({
  instantConfirm,
  isFlexDates,
  isMapCard,
  price,
  currencyCode,
  availability,
  isHotelOnly,
  hotelPageHref,
  isCardHovered,
  openInCurrentTab,
  datesInfo = '',
}) => (
  <div className={styles.priceBlock}>
    <HotelCardPrice
      price={price}
      currencyCode={currencyCode}
      availability={availability}
      isHotelOnly={isHotelOnly}
      instantConfirm={instantConfirm}
      isMobile={false}
      isFlexDates={isFlexDates}
      isMapCard={isMapCard}
      datesInfo={datesInfo}
    />
    <HotelCardExploreButton
      href={hotelPageHref}
      isCardHovered={isCardHovered}
      openInCurrentTab={openInCurrentTab}
      isHotelOnly={isHotelOnly}
    />
  </div>
);

export default HotelCardPriceBlock;
